var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mail-notification"},[_c('r-button',{attrs:{"type":"primary","disabled":!_vm.objectIds?.length},on:{"click":function($event){_vm.visible = true}}},[_vm._v(" Отправить уведомления ")]),(_vm.visible)?_c('modal-comp',{attrs:{"object-ids":_vm.objectIds,"module":_vm.module},on:{"close":_vm.close}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }